import React, { Component } from 'react';
import { reqGetUserAuthInstall } from "../../../api";
import SkeltonSpinnerLoading from '../../../components/SkeltonSpinnerLoading';
// import utils from '../../../utils/utils'
class install extends Component {
  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    this.UserAuthInstall(params);
  }

  /**
   * 通过从Shopify进入App的链接参数，后端判断当前用户的安装状态
   * 
   * @param {*} par Get请求链接上的参数对象
   */
  UserAuthInstall = async (par) => {
    try {
      const params = {
        'shop': par.get("shop"),
        'hmac': par.get("hmac"),
        'host': par.get("host"),
        'locale': par.get("locale"),
        'session': par.get("session"),
        'timestamp': par.get("timestamp")
      };
      /**
       * 返回code说明
       *  301 代表用户安装
       *  302 代表用户进入app
       */
      const response = await reqGetUserAuthInstall(params);
      switch (response.code) {
        case 301:
          window.location.href = response.url;
          break;

        case 302:
          this.props.history.push(response.url);
          // utils.routeListen(response.url)
          // utils.routeJump(this,response.url)
          break;

        default:
          this.setState({ errorMessage: response.msg });
      }

    } catch (error) {
      console.error(error)
    }
  }

  render() {

    return (
      <SkeltonSpinnerLoading />
      )
  }
}

export default install;